import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'
import { inactivateRotativeInventory } from 'action/rotativeInventory'
import { actionSet, resolve, reject } from './utils'
import { FORMAT_DATE_T } from 'constants/config'
import moment from 'moment'

import { getPages } from 'component/pagination/utils'
import User from 'utils/User'

import {
  FETCH_IRC_LIST_REQUEST,
  FETCH_IRC_LIST_SUCCESS,
  FETCH_IRC_LIST_ERROR,
  SAVE_IRC_LIST_REQUEST,
  SAVE_IRC_LIST_SUCCESS,
  DELETE_IRC_LIST_REQUEST,
  DELETE_IRC_LIST_SUCCESS,
  DELETE_IRC_LIST_ERROR,
  SAVE_IRC_LIST_ERROR,
  SAVE_IRC_LIST_RESET_ERROR,
  INVENTORY_CRITERIA_VALIDATE_PRODUCTS_BEFORE,
  INVENTORY_CRITERIA_VALIDATE_PRODUCTS_SUCCESS,
  INVENTORY_CRITERIA_VALIDATE_PRODUCTS_ERROR,
  FETCH_POSITIONS_SUCCESS,
  FETCH_POSITIONS_ERROR,
  FETCH_POSITIONS_LIST,
  FETCH_POSITIONS_LIST_ERROR,
  FETCH_POSITIONS_LIST_SUCCESS,
  SAVE_IRC_SUPPLY_LIST,
  EXCLUDE_IRC_SUPPLY_LIST,
  EXCLUDE_IRC_SUPPLY_LIST_SUCESS,
  EXCLUDE_IRC_SUPPLY_LIST_ERROR,

  FETCH_IRC_JUSTIFICATIONS_REQUEST,
  FETCH_IRC_JUSTIFICATIONS_SUCCESS,
  FETCH_IRC_JUSTIFICATIONS_ERROR,
  SAVE_IRC_JUSTIFICATION_REQUEST,
  SAVE_IRC_JUSTIFICATION_SUCCESS,
  SAVE_IRC_JUSTIFICATION_ERROR,
  SAVE_ALL_IRC_JUSTIFICATION_REQUEST,
  SAVE_ALL_IRC_JUSTIFICATION_SUCCESS,
  SAVE_ALL_IRC_JUSTIFICATION_ERROR,
  UPDATE_IRC_JUSTIFICATION_REQUEST,
  UPDATE_IRC_JUSTIFICATION_SUCCESS,
  UPDATE_IRC_JUSTIFICATION_ERROR,
  DELETE_IRC_JUSTIFICATION_REQUEST,
  DELETE_IRC_JUSTIFICATION_SUCCESS,
  DELETE_IRC_JUSTIFICATION_ERROR
} from 'actionTypes'


export const fetchIrcSupplyList =
  (token, params) =>
  async (dispatch) => {
    dispatch(actionSet(FETCH_POSITIONS_LIST))
    dispatch(showSpinner())

    try {

      const { data } = await new Api(token, dispatch).get(
        API_URL.IRC_MODELS_LIST,
        params
      )

      dispatch(actionSet(FETCH_POSITIONS_LIST_SUCCESS,data))
    } catch (error) {
      dispatch(actionSet(FETCH_POSITIONS_LIST_ERROR, error))
    }

    dispatch(hideSpinner())
  }

export const fetchIrcList =
  (token, _page = 1, params = {}) =>
  async (dispatch) => {
    dispatch(actionSet(FETCH_IRC_LIST_REQUEST))
    dispatch(showSpinner())

    const metadata = {
      _page,
      _limit: 10,
      ...params,
    }

    try {
      const { data } = await new Api(token, dispatch).get(
        API_URL.INVENTORY_CRITERIA_LIST,
        metadata
      )

      const user = new User()
      const { data: isUserMatriz } = await new Api(token, dispatch).get(API_URL.IS_USER_IN_HEADQUARTERS, {
        ldapNumber: user.currentUser.username
      })

      dispatch(getPages(data.pages))
      dispatch(
        actionSet(FETCH_IRC_LIST_SUCCESS, { data: data.inventoryCriteriaModelList, isUserMatriz })
      )
    } catch (error) {
      dispatch(actionSet(FETCH_IRC_LIST_ERROR, error))
    }

    dispatch(hideSpinner())
  }

  export const excludeSupplyList = (token, cdProcess) => async(dispatch) => {
    dispatch(actionSet(EXCLUDE_IRC_SUPPLY_LIST))
    dispatch(showSpinner())

    try {

      const response = await new Api(token, dispatch).get(
        API_URL.IRC_EXCLUDE_LIST + cdProcess
      )

      return resolve(dispatch, EXCLUDE_IRC_SUPPLY_LIST_SUCESS, response)
    } catch (error) {
      return reject(dispatch, EXCLUDE_IRC_SUPPLY_LIST_ERROR, error)
    } finally {
      dispatch(hideSpinner())
    }

  }

  export const saveIrcSupplyList = (token, ircSupplyData) => async(dispatch) => {
    dispatch(actionSet(SAVE_IRC_SUPPLY_LIST))
    dispatch(showSpinner())
    const ircSupplyRequestParam = {
      storeId: ircSupplyData.idBranch,
      inicialDate: ircSupplyData.dtBegin,
      finalDate: ircSupplyData.dtEnd,
      dtBegin: moment(ircSupplyData.dtBegin).format("L"),
      dtEnd: moment(ircSupplyData.dtEnd).format("L"),
      qtdlist: ircSupplyData.positionsPerDay,
      listDescription: ircSupplyData.dsListName,
      storageBinList: ircSupplyData.storageBinList

    }

    const countWharehouseRequest = [ircSupplyRequestParam]

    try {
      const { data } = await new Api(token, dispatch).post(
        API_URL.IRC_SAVE_POSITIONS ,
        {countWharehouseRequest}
      )

      return resolve(dispatch, SAVE_IRC_LIST_SUCCESS, data)
    } catch (error) {
      return reject(dispatch, FETCH_POSITIONS_LIST_ERROR, error)
    } finally {
      dispatch(hideSpinner())
    }

  }


export const saveIrcList = (token, ircData) => async (dispatch) => {
  dispatch(actionSet(SAVE_IRC_LIST_REQUEST))
  dispatch(showSpinner())

  const ircString =
    ircData.vlProductsAbove && ircData.vlProductsAbove.toString()
  const vlProductsAbove = (ircString || '').replace(/\./g, '').replace(',', '.')

  const params = {
    ...ircData,
    dtBegin: moment(ircData.dtBegin).format(FORMAT_DATE_T),
    dtEnd: moment(ircData.dtEnd).format(FORMAT_DATE_T),
    inAllBranchs: ircData.inAllBranchs ? 1 : 0,
    inProductsVlAbove: ircData.inProductsVlAbove ? 1 : 0,
    inProductsAvs: ircData.inProductsAvs ? 1 : 0,
    inProductsStockNeg: ircData.inProductsStockNeg ? 1 : 0,
    inItemsNoSale: ircData.inItemsNoSale ? 1 : 0,
    inProductsList: ircData.inProductsList ? 1 : 0,
    listRegionsAndBranchs: getListRegionsAndBranchs(ircData),
    listProducts: ircData.listProducts,
    inInactive: ircData.inInactive ? 1 : 0,
    inTopZero: ircData.inTopZero ? 1 : 0,
    inTopOne: ircData.inTopOne ? 1 : 0,
    inTopTwo: ircData.inTopTwo ? 1 : 0,
    vlProductsAbove,
  }

  try {
    const { data } = await new Api(token, dispatch).post(
      API_URL.INVENTORY_CRITERIA_SAVE,
      params
    )

    return resolve(dispatch, SAVE_IRC_LIST_SUCCESS, data)
  } catch (error) {
    return reject(dispatch, SAVE_IRC_LIST_ERROR, error)
  } finally {
    dispatch(hideSpinner())
  }
}

export const resetSaveError = () => async (dispatch) => {
  dispatch(actionSet(SAVE_IRC_LIST_RESET_ERROR))
}

const getListRegionsAndBranchs = (ircData) => {


  const list = ircData && ircData.listRegionsAndBranchs
    ? ircData.listRegionsAndBranchs
    : []

  if (!list.length) return []

  // When inAllBranchs is enabled, remove regional entries (value is a number)
  const filtered = ircData.inAllBranchs
    ? list.filter((item) => typeof item.value !== 'number' && item.value !== 'all')
    : list

  return filtered.map((item) => {
    const { value, label, isBranch, idBranchOrRegion, dsBranchOrRegion } = item

    return {
      idBranchOrRegion: value || idBranchOrRegion,
      dsBranchOrRegion: label || dsBranchOrRegion,
      inRegion: isBranch ? 0 : 1,
    }
  })
}

export const deleteIrcList = (token, ircData) => async (dispatch) => {
  dispatch(actionSet(DELETE_IRC_LIST_REQUEST))
  dispatch(showSpinner())

  const query = {
    idInventoryCriteria: ircData.idInventoryCriteria,
  }

  try {
    const { data } = await new Api(token, dispatch).post(
      API_URL.INVENTORY_CRITERIA_DELETE,
      query
    )

    dispatch(inactivateRotativeInventory(token, ircData.idInventoryCriteria))
    return resolve(dispatch, DELETE_IRC_LIST_SUCCESS, data)
  } catch (error) {
    return reject(dispatch, DELETE_IRC_LIST_ERROR, error)
  } finally {
    dispatch(hideSpinner())
  }
}

export const fetchPositions = (token, body) => (dispatch) => {
  dispatch(() => showSpinner())
  return new Api(token, dispatch)
    .post(API_URL.ANALYTICS_MENUS, body)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchPositionSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchPositionError(error))
      dispatch(hideSpinner())
    })

}

export const fetchPositionSuccess = (data) => ({
  type: FETCH_POSITIONS_SUCCESS,
  payload: data,
})

export const fetchPositionError = (error) => ({
  type: FETCH_POSITIONS_ERROR,
  payload: error,
})

export const validateProducts =
  (token, param, successCallback, signalController) => (dispatch) => {
    const controller = signalController || new AbortController()
    let handled = false

    const abort = () => {
      controller.abort()
      dispatch(hideSpinner())
      dispatch(hideSpinner())
    }

    const onClose = () => {
      dispatch(hideSpinner())
      dispatch(hideSpinner())
    }

    const onError = (error) => {
      if (handled) {
        return
      }
      handled = true
      const payload =
        (error && error.message && error.message.dsMessage) ||
        (error &&
          error.data &&
          error.data.message &&
          error.data.message.dsMessage) ||
        (error && error.message) ||
        (error && error.data) ||
        error
      dispatch(actionSet(INVENTORY_CRITERIA_VALIDATE_PRODUCTS_ERROR, payload))
      onClose()
    }

    const onMessage = (response) => {
      handled = true
      const data = response && response.data
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
      dispatch(actionSet(INVENTORY_CRITERIA_VALIDATE_PRODUCTS_SUCCESS, data))
      onClose()
    }

    dispatch(actionSet(INVENTORY_CRITERIA_VALIDATE_PRODUCTS_BEFORE))
    dispatch(showSpinner('', true, abort))

    const list = Array.isArray(param) ? param : []
    const cdLmList = list
      .map((item) => (typeof item === 'string' ? item : item && item.cdLm))
      .filter(Boolean)

    const query = { cdLm: cdLmList.join(',') }

    return new Api(token, dispatch)
      .eventSourceStream(
        API_URL.INVENTORY_CRITERIA_VALIDATE_PRODUCTS,
        query,
        null,
        controller,
        onMessage,
        onClose,
        onError
      )
      .catch((error) => {
        onError(error)
        return Promise.reject(error)
      })
  }


// Fetch all IRC Justifications
export const fetchIrcJustifications = (token, params) => async (dispatch) => {
  dispatch(actionSet(FETCH_IRC_JUSTIFICATIONS_REQUEST))
  dispatch(showSpinner())

  try {
    const response  = await new Api(token, dispatch).get(
      API_URL.IRC_LIST_JUSTIFICATIONS,
      params
    )
    dispatch(actionSet(FETCH_IRC_JUSTIFICATIONS_SUCCESS, response))
  } catch (error) {
    dispatch(actionSet(FETCH_IRC_JUSTIFICATIONS_ERROR, error))
  }

  dispatch(hideSpinner())
}

// Save a new IRC Justification
export const saveIrcJustification = (token, params, onSuccess, onError) => async (dispatch) => {
  dispatch(actionSet(SAVE_IRC_JUSTIFICATION_REQUEST))
  dispatch(showSpinner())

  try {
    const response = await new Api(token, dispatch).post(
      API_URL.IRC_SAVE_JUSTIFICATION,
      params
    )

    dispatch(actionSet(SAVE_IRC_JUSTIFICATION_SUCCESS, response))

     if (onSuccess) {
      onSuccess(response);
    }
  } catch (error) {
    dispatch(actionSet(SAVE_IRC_JUSTIFICATION_ERROR, error))

    if (onError) {
      onError(error);
    }
  }

  dispatch(hideSpinner())
}

export const saveAllIrcJustification = (token, params, onSuccess, onError) => async (dispatch) => {
  dispatch(actionSet(SAVE_ALL_IRC_JUSTIFICATION_REQUEST))
  dispatch(showSpinner())

  try {
    const response = await new Api(token, dispatch).post(
      API_URL.IRC_SAVE_ALL_JUSTIFICATION,
      params
    )

    dispatch(actionSet(SAVE_ALL_IRC_JUSTIFICATION_SUCCESS, response))

     if (onSuccess) {
      onSuccess(response);
    }
  } catch (error) {
    dispatch(actionSet(SAVE_ALL_IRC_JUSTIFICATION_ERROR, error))

    if (onError) {
      onError(error);
    }
  }

  dispatch(hideSpinner())
}

// Update an existing IRC Justification
export const fetchUpdateIrcJustification = (token, params, onSuccess, onError) => async (dispatch) => {
  dispatch(actionSet(UPDATE_IRC_JUSTIFICATION_REQUEST))
  dispatch(showSpinner())

  try {
    const response = await new Api(token, dispatch).put(
      API_URL.IRC_UPDATE_JUSTIFICATION,
      params
    )

    dispatch(actionSet(UPDATE_IRC_JUSTIFICATION_SUCCESS, response))

    if (onSuccess) {
      onSuccess(response);
    }

  } catch (error) {
    dispatch(actionSet(UPDATE_IRC_JUSTIFICATION_ERROR, error))

    if (onError) {
      onError(error);
    }
  }

  dispatch(hideSpinner())
}

// Delete an IRC Justification
export const fetchDeleteIrcJustification = (token, params) => async (dispatch) => {
  dispatch(actionSet(DELETE_IRC_JUSTIFICATION_REQUEST))
  dispatch(showSpinner())

  try {
    const response = await new Api(token, dispatch).delete(
      API_URL.IRC_DELETE_JUSTIFICATION,
      params
    )
    dispatch(actionSet(DELETE_IRC_JUSTIFICATION_SUCCESS, response))
  } catch (error) {
    dispatch(actionSet(DELETE_IRC_JUSTIFICATION_ERROR, error))
  }

  dispatch(hideSpinner())
}
